// src/pages/admin/user/UserList.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../../layouts/admin/AdminLayout";
import api from "../../../api/axios";

export default function UserList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const fmtDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return d;
    const yyyy = dt.getFullYear();
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const dd = String(dt.getDate()).padStart(2, "0");
    return `${yyyy}.${mm}.${dd}`;
  };

  const fmtDateTime = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return d;
    const yyyy = dt.getFullYear();
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const dd = String(dt.getDate() + 0).padStart(2, "0");
    const hh = String(dt.getHours()).padStart(2, "0");
    const mi = String(dt.getMinutes()).padStart(2, "0");
    return `${yyyy}.${mm}.${dd} ${hh}:${mi}`;
  };

  const toUserTypeLabel = (type) => {
    if (type === "ADMIN") return "관리자";
    if (type === "USER") return "일반";
    return type || "-";
  };

  const loadUsers = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.get("/api/user/list");
      const resultCode = res.data?.resultCode;
      if (resultCode !== "200" && resultCode !== 200) {
        setError(res.data?.resultMessage || "계정 목록을 불러오지 못했습니다.");
        setUsers([]);
        return;
      }
      const list = Array.isArray(res.data?.data) ? res.data.data : [];
      setUsers(list);
    } catch (err) {
      console.error(err);
      if (err.response?.status === 401) {
        setError("로그인이 필요합니다.");
        navigate("/login");
      } else {
        setError(
          err.response?.data?.resultMessage ||
            "계정 목록을 불러오는 중 오류가 발생했습니다."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AdminLayout>
      {/* 헤더 영역 */}
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-extrabold tracking-tight text-blue-900 md:text-3xl">
            관리자 계정 관리
          </h1>
          <p className="mt-1 text-sm text-slate-500">
            등록된 관리자 / 사용자 계정을 조회할 수 있습니다.
          </p>
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => navigate("/admin/user/register")}
            className="rounded-xl bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700"
          >
            계정 추가
          </button>
        </div>
      </div>

      {/* 콘텐츠 영역 */}
      <div className="rounded-2xl border bg-white p-4 shadow-sm">
        {loading ? (
          <div className="py-10 text-center text-sm text-slate-500">
            계정 목록을 불러오는 중입니다...
          </div>
        ) : error ? (
          <div className="py-10 text-center text-sm text-red-600">{error}</div>
        ) : users.length === 0 ? (
          <div className="py-10 text-center text-sm text-slate-500">
            등록된 계정이 없습니다.
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-slate-200 text-sm">
              <thead className="bg-slate-50">
                <tr>
                  <th className="whitespace-nowrap px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
                    No
                  </th>
                  <th className="whitespace-nowrap px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
                    이름
                  </th>
                  <th className="whitespace-nowrap px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
                    이메일
                  </th>
                  {/* <th className="whitespace-nowrap px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
                    계정 유형
                  </th>
                  <th className="whitespace-nowrap px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
                    생년월일
                  </th>
                  <th className="whitespace-nowrap px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
                    전화번호
                  </th>
                  <th className="whitespace-nowrap px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
                    주소
                  </th> */}
                  <th className="whitespace-nowrap px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
                    생성일
                  </th>
                  {/* ✅ 상세보기 컬럼 추가 */}
                  <th className="whitespace-nowrap px-3 py-2 text-right text-xs font-semibold uppercase tracking-wide text-slate-500">
                    관리
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 bg-white">
                {users.map((u) => (
                  <tr key={u.userId}>
                    <td className="whitespace-nowrap px-3 py-2 text-xs text-slate-500">
                      {u.userId}
                    </td>
                    <td className="whitespace-nowrap px-3 py-2 font-medium text-slate-900">
                      {u.name}
                    </td>
                    <td className="whitespace-nowrap px-3 py-2 text-slate-700">
                      {u.email}
                    </td>
                    {/* <td className="whitespace-nowrap px-3 py-2 text-slate-700">
                      {toUserTypeLabel(u.userType)}
                    </td>
                    <td className="whitespace-nowrap px-3 py-2 text-slate-700">
                      {fmtDate(u.birthDate)}
                    </td>
                    <td className="whitespace-nowrap px-3 py-2 text-slate-700">
                      {u.phone || "-"}
                    </td>
                    <td className="px-3 py-2 text-slate-700">
                      {u.address || "-"}
                    </td> */}
                    <td className="whitespace-nowrap px-3 py-2 text-slate-700">
                      {fmtDateTime(u.createdAt)}
                    </td>
                    {/* ✅ 여기 상세보기 버튼 */}
                    <td className="whitespace-nowrap px-3 py-2 text-right">
                      <button
                        type="button"
                        onClick={() => navigate(`/admin/users/${u.userId}`)}
                        className="rounded-lg border px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50"
                      >
                        상세보기
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
